export default __webpack_public_path__ + "static/media/war4.c396e5d1.png";